import { INTAKE_MESSAGE_TYPES } from './IntakeReplyForm'

export const isPostTypePromptFile = (post: any) => {
  if (!post || !post.props) {
    return false
  }
  return post.props?.type === INTAKE_MESSAGE_TYPES.prompt_file
}
